import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';

export interface SecurityAuditLogDto {
  id: string;
  companyId: string;
  actorUserId?: string | null;
  actorUsername?: string | null;
  targetUserId?: string | null;
  targetUsername?: string | null;
  eventType: string;
  description?: string | null;
  oldValue?: string | null;
  newValue?: string | null;
  ipAddress?: string | null;
  remarks?: string | null;
  success: boolean;
  createdDate: string;
}

export interface SecurityAuditFilterDto {
  eventType?: string;
  actorUserId?: string;
  targetUserId?: string;
  dateFrom?: string;
  dateTo?: string;
  success?: boolean;
  pageNumber?: number;
  pageSize?: number;
  search?: string;
}

export const securityAuditApi = {
  /** GET /api/v1/security-audit — paginated, filterable audit log */
  getList: (filter?: SecurityAuditFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<SecurityAuditLogDto>>>('/security-audit', {
      params: filter,
    }),
};
